<template>
  <div
    class="toggle-switch"
    :class="{ 'is-checked': modelValue, 'is-disabled': disabled }"
    @click="handleToggle"
  >
    <div class="switch-circle"></div>
  </div>
</template>

<script>
export default {
  name: 'ToggleSwitch',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  methods: {
    handleToggle() {
      if (!this.disabled) {
        this.$emit('update:modelValue', !this.modelValue);
      }
    }
  }
};
</script>

<style scoped>
.toggle-switch {
  position: relative;
  width: 40px;
  height: 22px;
  background: #F9FBFD;
  border: 1px solid #374957;
  border-radius: 13px;
  padding:  2px 1px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  transition: background-color 0.3s cubic-bezier(0.4, 0, 0.2, 1),
              border-color 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.toggle-switch:hover:not(.is-disabled) {
  opacity: 0.9;
}

.toggle-switch.is-disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.toggle-switch.is-checked {
  background: #374957;
  border-color: #374957;
  justify-content: flex-end;
}

.switch-circle {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #374957;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.25);
  transition: background-color 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.toggle-switch.is-checked .switch-circle {
  background: #FFFFFF;
}
</style>
